export default __webpack_public_path__ + "static/media/src1_melodyne.507e9923.mp3";